module.exports = __webpack_public_path__ + "img/xcb-subject-item-10-1@2x.e58a7d97.png";